import { CommitteeApprovalType } from './committee-approval-type';
import { User } from '../../interfaces/user';
import Milestone from '../../interfaces/milestone';
import Project from '../../interfaces/project';
export const CommitteeApprovalStatus: { [key: string]: string | null } = {
  '-- Select --': null,
  Cleared: 'APPROVED',
  'Not Cleared': 'DENIED',
  'Cleared with Disclosures': 'CONDITIONAL',
  'Requires Discussion': 'DISCUSSION',
};

export const ClosingApprovalStatus: { [key: string] : string | null } = {
  '-- Select --' : null,
  'Approve Fund & Release' : 'RELEASE',
  'Approve Fund Only' : 'FUND',
  'Not Approved': 'DENIED'
};

export interface CommitteeApproval {
  id?: string;
  status?: string | null;
  committee_approval_type_id?: number;
  committeeApprovalType?: CommitteeApprovalType;
  milestone?: Milestone;
  milestone_id?: string;
  project_id?: string;
  project?: Project;
  user?: User;
  created?: string;
  modified?: string;
  __typename: 'CommitteeApproval';
}
